import { render, staticRenderFns } from "./Beauticians.vue?vue&type=template&id=5a6e8209"
import script from "./Beauticians.vue?vue&type=script&lang=js"
export * from "./Beauticians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports